import { render } from "./TimerDuration.vue?vue&type=template&id=61cce654"
import script from "./TimerDuration.vue?vue&type=script&lang=js"
export * from "./TimerDuration.vue?vue&type=script&lang=js"
script.render = render

export default script